<template>
  <v-card>
    <v-card-text>
      <div class="mb-4">
        <div class="font-size-14 font-weight-bold mb-1">
          Оберіть клас документів
        </div>
        <div class="font-size-12 text-disabled">
          Форми пошуку для різних класів документів різні — кожен клас має
          власний набір атрибутів. Натисніть на ярлик потрібного класу, щоб
          перейти до форми пошуку.
        </div>
      </div>

      <v-row>
        <v-col
          v-for="(item, index) in $directory.get('docTypeClasses')"
          :key="item.id"
          cols="12"
          lg="3"
          md="6">
          <v-card
            border
            class="search-class-card h-100 cursor-pointer bg-white"
            @click="openClass(item.id)">
            <v-card-text class="d-flex flex-column ga-3">
              <div class="d-flex align-center ga-4">
                <v-sheet
                  class="d-flex align-center justify-center flex-shrink-0 bg-white"
                  height="42"
                  rounded="lg"
                  width="42">
                  <v-icon
                    :color="getClassColor(index)"
                    :icon="getClassIcon(index)"
                    size="22"></v-icon>
                </v-sheet>
                <div class="font-size-14 font-weight-bold">
                  {{ item.name }}
                </div>
              </div>
              <div class="font-size-12">
                {{ item.description || 'Документи цього класу' }}
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { fillDirectory } from '@/directory'

defineOptions({
  name: 'AttributeSearch',
})

const router = useRouter()

const classColors = [
  'secondary',
  'deep-purple-accent-3',
  'warning',
  'success',
  'error',
  'blue-darken-3',
  'deep-purple-accent-3',
  'warning',
]

const classIcons = [
  'mdi-file-document-outline',
  'mdi-archive-outline',
  'mdi-check-decagram-outline',
  'mdi-message-outline',
  'mdi-file-document-alert-outline',
  'mdi-calendar-blank-outline',
  'mdi-book-open-page-variant-outline',
  'mdi-account-key-outline',
]

onMounted(() => {
  fillDirectory('docTypeClasses')
})

const openClass = (classId: number) => {
  router.push({
    name: 'eds-search-attribute-class',
    params: { classKey: classId },
  })
}

const getClassColor = (index: number) => {
  return classColors[index % classColors.length]
}

const getClassIcon = (index: number) => {
  return classIcons[index % classIcons.length]
}
</script>

<style lang="scss" scoped>
.search-class-card {
  transition: border-color 0.15s, box-shadow 0.15s, transform 0.15s;

  &:hover {
    border-color: rgb(var(--v-theme-secondary)) !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
    transform: translateY(-2px);
  }
}
</style>
